'use client';

import { c as _c } from "react/compiler-runtime";
import { PolicyInfo } from '@module/apis/client-side/policy';
import type { IPolicyInfo } from '@module/apis/client-side/policy/type';
import { useEffect, useRef, useState } from 'react';
import './PoliceContent.scss';
import useModalStore from '@module/stores/useModalStore';
import { BaseHttpResponseError } from '@module/utils/error/apiErrors';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@pc/components/ui/select';
function PoliceContent(t0) {
  const $ = _c(21);
  const {
    type
  } = t0;
  const {
    pushModal
  } = useModalStore();
  const [mes, setMes] = useState(null);
  const [version, setVersion] = useState(null);
  const containerRef = useRef(null);
  let t1;
  if ($[0] !== pushModal || $[1] !== type) {
    t1 = async v => {
      ;
      try {
        const res = await PolicyInfo({
          page: type,
          version: v
        });
        setMes(res);
      } catch (t2) {
        const err = t2;
        if (err instanceof BaseHttpResponseError) {
          pushModal({
            type: "CONFIRM_MODAL",
            id: "PoliceContent",
            options: {
              description: err.message
            }
          });
        }
      }
    };
    $[0] = pushModal;
    $[1] = type;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getInfoHandler = t1;
  let t2;
  if ($[3] !== getInfoHandler || $[4] !== version) {
    t2 = () => {
      getInfoHandler(version || "");
    };
    $[3] = getInfoHandler;
    $[4] = version;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== version) {
    t3 = [version];
    $[6] = version;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== mes?.html) {
    t4 = () => {
      const el = containerRef.current;
      if (!mes?.html || !el) {
        return;
      }
      el.querySelectorAll("h3").forEach(_temp);
      const hash = decodeURIComponent(window.location.hash.slice(1));
      if (hash) {
        document.getElementById(hash)?.scrollIntoView({
          block: "center"
        });
      }
    };
    $[8] = mes?.html;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== mes) {
    t5 = [mes];
    $[10] = mes;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  if ($[12] !== mes || $[13] !== type || $[14] !== version) {
    t6 = mes && mes.versionList.length > 1 && type !== "cast" && <div className="mt-10 mb-5 flex justify-end px-5"><Select value={version || ""} onValueChange={value => {
        setVersion(value);
      }}><SelectTrigger className="w-[240px] bg-transparent"><SelectValue placeholder={type === "privacy" ? "\uC774\uC804 \uAC1C\uC778\uC815\uBCF4\uBC29\uCE68 \uBCF4\uAE30" : "\uC774\uC804 \uC774\uC6A9\uC57D\uAD00 \uBCF4\uAE30"} /></SelectTrigger><SelectContent><SelectItem key={0} value=" ">{type === "privacy" ? "\uC774\uC804 \uAC1C\uC778\uC815\uBCF4\uBC29\uCE68 \uBCF4\uAE30" : "\uC774\uC804 \uC774\uC6A9\uC57D\uAD00 \uBCF4\uAE30"}</SelectItem>{mes.versionList.reverse().map(_temp2)}</SelectContent></Select></div>;
    $[12] = mes;
    $[13] = type;
    $[14] = version;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const t7 = mes?.html || "";
  let t8;
  if ($[16] !== t7) {
    t8 = <div ref={containerRef} className="etcCon" dangerouslySetInnerHTML={{
      __html: t7
    }} />;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t8) {
    t9 = <div className="mt-[25px]">{t6}{t8}</div>;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}
function _temp2(el_0) {
  const year = el_0.EnforceDate.split("-")[0];
  const month = el_0.EnforceDate.split("-")[1];
  const day = el_0.EnforceDate.split("-")[2];
  return <SelectItem key={el_0.version} value={el_0.version}>{`시행일 ${year}년 ${month}월 ${day}일`}</SelectItem>;
}
function _temp(h) {
  const m = h.textContent?.match(/제\s*(\d+)\s*조/);
  if (m) {
    h.id = `제${m[1]}조`;
  }
}
export default PoliceContent;